import React from 'react'
import ProjectCard from './ProjectCard'
import ProjectCardEdit from './ProjectCardEdit'
import './Columns.css';

const Columns = (props) => {
    function getProjectCard(i, p, isFavorite) {
        return props.user ?
            <ProjectCardEdit project={{ ...p }} key={i} user={props.user} /> :
            <ProjectCard {...p} key={i} isFavorite={isFavorite ? true : false} favoriteClick={props.favoriteClick} />
    }

    if(!props.projects) return ''
    return (        
        <div className="columns">
            {props.projects.map((p, i) => {

                return getProjectCard(i, p, props.favorites && props.favorites.find(x => x.id === p.id))
            }
            )}
        </div>
    )

}

export default Columns